import '@fontsource/ibm-plex-mono/latin-300.css'
import '@fontsource/ibm-plex-mono/latin-400.css'
import '@fontsource/ibm-plex-mono/latin-500.css'
import '@fontsource/ibm-plex-mono/latin-400-italic.css'
import '@fontsource/cormorant-garamond/latin-400.css'
import '@fontsource/cormorant-garamond/latin-500.css'
import '@fontsource/cormorant-garamond/latin-400-italic.css'

import './tokens.css'
import './app.css'

import { createApp } from './app.ts'

/**
 * The entry point. Fonts are self-hosted rather than fetched from a third
 * party (Q7.1), the tokens come from the design prototype, and everything else
 * is the shell.
 */
const root = document.querySelector('#app')
if (root instanceof HTMLElement) void createApp(root)
